import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import _isNumber from "lodash/isNumber";
import _isEmpty from "lodash/isEmpty";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import moment from 'moment';
import { BORROWERS_SEARCH_TYPE, dateFormat } from 'enums';
var name = BORROWERS_SEARCH_TYPE.name,
    id_number = BORROWERS_SEARCH_TYPE.id_number,
    phone = BORROWERS_SEARCH_TYPE.phone,
    area = BORROWERS_SEARCH_TYPE.area,
    city = BORROWERS_SEARCH_TYPE.city,
    address = BORROWERS_SEARCH_TYPE.address;
export var getBorrowerModel = function getBorrowerModel(data) {
  var _data$phones;

  return !_isEmpty(data) ? _objectSpread(_objectSpread({}, data), {}, {
    has_current_work_experience_more_than_6: Boolean(data === null || data === void 0 ? void 0 : data.has_current_work_experience_more_than_6),
    has_income_above_average_salary: Boolean(data === null || data === void 0 ? void 0 : data.has_income_above_average_salary),
    has_loan_payment_delays_more_than_30_days: Boolean(data === null || data === void 0 ? void 0 : data.has_loan_payment_delays_more_than_30_days),
    has_more_than_5_loans: Boolean(data === null || data === void 0 ? void 0 : data.has_more_than_5_loans),
    has_official_income: Boolean(data === null || data === void 0 ? void 0 : data.has_official_income),
    is_retired: Boolean(data === null || data === void 0 ? void 0 : data.is_retired),
    other_citizenship: Boolean(data === null || data === void 0 ? void 0 : data.other_citizenship),
    political_figure: Boolean(data === null || data === void 0 ? void 0 : data.political_figure),
    has_late_payments: Boolean(data === null || data === void 0 ? void 0 : data.has_late_payments),
    phones: data === null || data === void 0 ? void 0 : (_data$phones = data.phones) === null || _data$phones === void 0 ? void 0 : _data$phones.map(function (el) {
      return el === null || el === void 0 ? void 0 : el.phone;
    }),
    sameAddresses: (data === null || data === void 0 ? void 0 : data.id_card_area) === (data === null || data === void 0 ? void 0 : data.current_area) && (data === null || data === void 0 ? void 0 : data.id_card_city) === (data === null || data === void 0 ? void 0 : data.current_city) && (data === null || data === void 0 ? void 0 : data.id_card_address) === (data === null || data === void 0 ? void 0 : data.current_address)
  }) : null;
};
export var getAllBorrowerModel = function getAllBorrowerModel(response) {
  var _response$data;

  return _objectSpread(_objectSpread({}, response), {}, {
    data: (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.map(function (el) {
      return getBorrowerModel(el);
    })
  });
};
export var borrowerBody = function borrowerBody(data) {
  return _objectSpread(_objectSpread({}, data), {}, {
    id_card_issued_date: moment.isMoment(data === null || data === void 0 ? void 0 : data.id_card_issued_date) ? data === null || data === void 0 ? void 0 : data.id_card_issued_date.format(dateFormat) : data === null || data === void 0 ? void 0 : data.id_card_issued_date,
    id_card_valid_to_date: moment.isMoment(data === null || data === void 0 ? void 0 : data.id_card_valid_to_date) ? data === null || data === void 0 ? void 0 : data.id_card_valid_to_date.format(dateFormat) : data === null || data === void 0 ? void 0 : data.id_card_valid_to_date,
    current_area_id: data !== null && data !== void 0 && data.sameAddresses ? data === null || data === void 0 ? void 0 : data.id_card_area_id : data === null || data === void 0 ? void 0 : data.current_area_id,
    current_municipality_id: data !== null && data !== void 0 && data.sameAddresses ? data === null || data === void 0 ? void 0 : data.id_card_municipality_id : data === null || data === void 0 ? void 0 : data.current_municipality_id,
    current_city_id: data !== null && data !== void 0 && data.sameAddresses ? data === null || data === void 0 ? void 0 : data.id_card_city_id : data === null || data === void 0 ? void 0 : data.current_city_id,
    current_quarter: data !== null && data !== void 0 && data.sameAddresses ? data === null || data === void 0 ? void 0 : data.id_card_quarter : data === null || data === void 0 ? void 0 : data.current_quarter,
    current_street: data !== null && data !== void 0 && data.sameAddresses ? data === null || data === void 0 ? void 0 : data.id_card_street : data === null || data === void 0 ? void 0 : data.current_street,
    current_building: data !== null && data !== void 0 && data.sameAddresses ? data === null || data === void 0 ? void 0 : data.id_card_building : data === null || data === void 0 ? void 0 : data.current_building,
    current_floor: data !== null && data !== void 0 && data.sameAddresses ? data === null || data === void 0 ? void 0 : data.id_card_floor : data === null || data === void 0 ? void 0 : data.current_floor,
    current_street_number: data !== null && data !== void 0 && data.sameAddresses ? data === null || data === void 0 ? void 0 : data.id_card_street_number : data === null || data === void 0 ? void 0 : data.current_street_number,
    current_apartment: data !== null && data !== void 0 && data.sameAddresses ? data === null || data === void 0 ? void 0 : data.id_card_apartment : data === null || data === void 0 ? void 0 : data.current_apartment,
    current_entrance: data !== null && data !== void 0 && data.sameAddresses ? data === null || data === void 0 ? void 0 : data.id_card_entrance : data === null || data === void 0 ? void 0 : data.current_entrance
  });
};

var getImagesModel = function getImagesModel(response) {
  var obj = {};
  response === null || response === void 0 ? void 0 : response.forEach(function (el) {
    obj[el === null || el === void 0 ? void 0 : el.type] = _objectSpread(_objectSpread({}, el), {}, {
      data: el === null || el === void 0 ? void 0 : el.image,
      name: el === null || el === void 0 ? void 0 : el.type
    });
  });
  return {
    current: obj,
    all: response
  };
};

export var getDocumentsModel = function getDocumentsModel(data) {
  return !_isEmpty(data) ? getImagesModel(data) : null;
};

var addImagesBody = function addImagesBody(response) {
  var imagesArray = Object.entries(response).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        type = _ref2[0],
        value = _ref2[1];

    return {
      type: type,
      image: value === null || value === void 0 ? void 0 : value.data
    };
  });
  return {
    images: imagesArray
  };
};

export var documentsBody = function documentsBody(data) {
  return addImagesBody(data);
};
export var allBorrowersParams = function allBorrowersParams(data) {
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, (data === null || data === void 0 ? void 0 : data.pageSize) && {
    per_page: data === null || data === void 0 ? void 0 : data.pageSize
  }), (data === null || data === void 0 ? void 0 : data.pageIndex) && {
    page: (data === null || data === void 0 ? void 0 : data.pageIndex) + 1
  }), (data === null || data === void 0 ? void 0 : data.search) && (data === null || data === void 0 ? void 0 : data.searchBy) === name && {
    name: data === null || data === void 0 ? void 0 : data.search
  }), (data === null || data === void 0 ? void 0 : data.search) && (data === null || data === void 0 ? void 0 : data.searchBy) === id_number && {
    id_number: data === null || data === void 0 ? void 0 : data.search
  }), (data === null || data === void 0 ? void 0 : data.search) && (data === null || data === void 0 ? void 0 : data.searchBy) === phone && {
    phone: data === null || data === void 0 ? void 0 : data.search
  }), (data === null || data === void 0 ? void 0 : data.search) && (data === null || data === void 0 ? void 0 : data.searchBy) === area && {
    area: data === null || data === void 0 ? void 0 : data.search
  }), (data === null || data === void 0 ? void 0 : data.search) && (data === null || data === void 0 ? void 0 : data.searchBy) === city && {
    city: data === null || data === void 0 ? void 0 : data.search
  }), (data === null || data === void 0 ? void 0 : data.search) && (data === null || data === void 0 ? void 0 : data.searchBy) === address && {
    address: data === null || data === void 0 ? void 0 : data.search
  }), (data === null || data === void 0 ? void 0 : data.min_count_credits) && {
    min_count_credits: data === null || data === void 0 ? void 0 : data.min_count_credits
  }), (data === null || data === void 0 ? void 0 : data.max_count_credits) && {
    max_count_credits: data === null || data === void 0 ? void 0 : data.max_count_credits
  }), _isNumber(data === null || data === void 0 ? void 0 : data.has_active_credits) && {
    has_active_credits: Boolean(data === null || data === void 0 ? void 0 : data.has_active_credits)
  }), _isNumber(data === null || data === void 0 ? void 0 : data.has_late_payments) && {
    has_late_payments: Boolean(data === null || data === void 0 ? void 0 : data.has_late_payments)
  }), (data === null || data === void 0 ? void 0 : data.employee) && {
    employee_id: data === null || data === void 0 ? void 0 : data.employee
  }), (data === null || data === void 0 ? void 0 : data.office) && {
    office_id: data === null || data === void 0 ? void 0 : data.office
  });
};